<template>
  <div>

  </div>

</template>

<script>

import { resolve } from "path";
import { Toast } from "vant";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {

  },
  computed: {
   
  },
  data() {
    return {
      
    };
  },
  async mounted() {

    console.log(window.location.host)
    let typeList = ['tuoyu','yingyou','jiazhang06','jiazhang03']
    let info = typeList.find(item=>{
      return window.location.host.includes(item)
    })
    this.$router.replace('../'+info+'/index');
  },
  methods: {
    goDetail(id) {
      if(!id) return
      let url = `./detail?id=${id}` 
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss">
  
</style>
